import { Box, Flex } from '@chakra-ui/react'
import { gynPracticeSelectField } from '../../collections/fields/practice'
import { Editable } from '../forms/Input'
import { Subheader } from '../Users/Text'
import { useGynCareView } from './context'

export const GynMidwifeSelect = ({ mobileLayout }: { mobileLayout: boolean }) => {
  const { practiceId, onSubmit, canChangePractice } = useGynCareView()
  return (
    <Flex
      align={mobileLayout ? 'flex-start' : 'center'}
      bg="white"
      flexFlow={mobileLayout ? 'column' : 'row'}
      borderRadius={4}
      justify={mobileLayout ? 'flex-start' : 'space-between'}
      border="1px solid #cdcdcd"
      px={3}
      pb={1}
      pt={mobileLayout ? 2 : 1}
      w="100%">
      <Subheader color="gray.600" fontWeight={500}>
        GYN Care Provider
      </Subheader>
      <Box
        flex={mobileLayout ? 'unset' : 1}
        w={mobileLayout ? '100%' : 'auto'}
        maxW={mobileLayout ? 'unset' : '450px'}
        minW={0}>
        <Editable
          theme="detailed"
          initEditing={!practiceId && canChangePractice}
          dataCellProps={{
            fontSize: 'lg',
            textAlign: mobileLayout ? 'left' : 'right',
            justifyContent: mobileLayout ? 'flex-start' : 'flex-end',
          }}
          onSubmit={canChangePractice ? data => onSubmit({ practiceId: data }) : undefined}
          field={gynPracticeSelectField}
          value={practiceId}
        />
      </Box>
    </Flex>
  )
}
